<template>
  <v-container fluid>
    <v-row>
      <v-col class="text-h3 gray--text"> História da moléstia atual </v-col>
      <v-col cols="auto" class="mt-2">
        <SaveStatus
          :saving="saveManager.isSaving"
          :pending="saveManager.pendingSave"
          :saved-at="historyPresentIllness.updatedAt"
          :error="hasErrors || saveManager.isError"
          :loading="isLoading"
          not-saved-message="O H.M.A. ainda não foi salvo."
        />
      </v-col>
      <v-col cols="auto">
        <v-btn
          color="light-blue"
          dark
          @click="saveManager.triggerManualSave()"
          :loading="isLoading || saveManager.isSaving"
          :disabled="attendanceEsigned"
        >
          Salvar H.M.A.
        </v-btn>
      </v-col>
    </v-row>

    <MedicalRecordHmaSkeletonLoader v-if="isLoading" />
    <v-row v-else>
      <v-col>
        <v-row dense>
          <v-col>
            <v-combobox
              v-model="facilitator"
              outlined
              dense
              hide-details
              label="Introdução"
              :items="facilitator_introduction"
              @change="handleFacilitatorChange"
              background-color="white"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-combobox
              v-model="facilitator"
              outlined
              dense
              hide-details
              label="Queixa"
              :items="facilitator_complaint"
              @change="handleFacilitatorChange"
              background-color="white"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-combobox
              v-model="facilitator"
              outlined
              dense
              hide-details
              label="Procedimento"
              :items="facilitator_procedure"
              @change="handleFacilitatorChange"
              background-color="white"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-combobox
              v-model="facilitator"
              outlined
              dense
              hide-details
              label="Sinal"
              :items="facilitator_sign"
              @change="handleFacilitatorChange"
              background-color="white"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-combobox
              v-model="facilitator"
              outlined
              dense
              hide-details
              label="Local"
              :items="facilitator_site"
              @change="handleFacilitatorChange"
              background-color="white"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-combobox
              v-model="facilitator"
              outlined
              dense
              hide-details
              label="Tempo"
              :items="facilitator_period"
              @change="handleFacilitatorChange"
              background-color="white"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>
      </v-col>

      <v-col>
        <v-row dense>
          <v-col>
            <v-textarea
              v-model="historyPresentIllness.description"
              v-uppercase
              solo
              dense
              rows="17"
              placeholder="Digite a história da moléstia atual..."
              background-color="white"
              :hide-details="!hasErrors"
              :error-messages="errors.description"
              :disabled="attendanceEsigned"
              @input="handleFormChange"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GET_HISTORY_PRESENT_ILLNESS_FACILITATORS from "@/graphql/history_present_illness_facilitators.gql";
import GET_HISTORY_PRESENT_ILLNESS from "@/graphql/history_present_illness.gql";
import SAVE_HISTORY_PRESENT_ILLNESS from "@/graphql/save_history_present_illness.gql";

import MedicalRecordHmaSkeletonLoader from "@/components/medical_record/hma/skeleton_loader.vue";
import SaveStatus from "@/components/ui/form/save_status/index.vue";

import { AutoSaveManager } from "@/services/AutoSaveManager/index.js";

export default {
  name: "HMA",
  components: { MedicalRecordHmaSkeletonLoader, SaveStatus },
  props: {
    attendance: Object,
    attendanceEsigned: Boolean,
  },
  data() {
    return {
      historyPresentIllnessFacilitators: [],
      historyPresentIllness: {},
      facilitator: [],
      errors: {},
      saveManager: null,
    };
  },
  apollo: {
    historyPresentIllnessFacilitators: {
      query: GET_HISTORY_PRESENT_ILLNESS_FACILITATORS,
    },
    historyPresentIllness: {
      query: GET_HISTORY_PRESENT_ILLNESS,
      fetchPolicy: "no-cache",
      variables() {
        return {
          attendanceId: this.attendance.id,
        };
      },
    },
  },
  created() {
    this.saveManager = new AutoSaveManager({
      formName: "H.M.A",
      beforeSave: () => this.beforeSave(),
      onSave: () => this.onSave(),
    });
  },
  watch: {
    $route() {
      this.saveHistoryPresentIllness();
    },
  },
  computed: {
    isLoading() {
      if (this.$apollo.queries.historyPresentIllnessFacilitators.loading) {
        return true;
      }

      return !this.historyPresentIllness.id;
    },
    facilitator_introduction() {
      return this.lodash.filter(this.orderedfacilitators, {
        facilitatorType: "introduction",
      });
    },
    facilitator_procedure() {
      return this.lodash.filter(this.orderedfacilitators, {
        facilitatorType: "procedure",
      });
    },
    facilitator_site() {
      return this.lodash.filter(this.orderedfacilitators, {
        facilitatorType: "site",
      });
    },
    facilitator_complaint() {
      return this.lodash.filter(this.orderedfacilitators, {
        facilitatorType: "complaint",
      });
    },
    facilitator_sign() {
      return this.lodash.filter(this.orderedfacilitators, {
        facilitatorType: "sign",
      });
    },
    facilitator_period() {
      return this.lodash.filter(this.orderedfacilitators, {
        facilitatorType: "period",
      });
    },
    orderedfacilitators() {
      return this.lodash.orderBy(
        this.historyPresentIllnessFacilitators,
        [
          (e) =>
            e.text
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, ""),
        ],
        ["asc"]
      );
    },
    hasErrors() {
      return Object.keys(this.errors).length > 0;
    },
  },
  methods: {
    handleFacilitatorChange(e) {
      if (this.attendanceEsigned) return;

      if (e) {
        if (this.historyPresentIllness.description !== null) {
          this.historyPresentIllness.description += ` ${e.text}`;
          this.historyPresentIllness.description = this.historyPresentIllness.description.trim();
        } else {
          this.historyPresentIllness.description = ` ${e.text}`;
        }
      }

      this.facilitator = [];
      this.handleFormChange();
    },
    handleFormChange() {
      this.saveManager.dispatchAutoSave();
    },
    beforeSave() {
      this.validateForm();

      if (this.hasErrors) return false;
      if (this.attendanceEsigned) return false;

      return true;
    },
    async onSave() {
      let description = this.historyPresentIllness.description;
      if (description === null) {
        description = "";
      }

      const { data } = await this.apolloMutate({
        mutation: SAVE_HISTORY_PRESENT_ILLNESS,
        variables: {
          attendanceId: this.attendance.id,
          description: description,
        },
      });

      const updatedAt = data.saveHistoryPresentIllness.updatedAt;

      this.$set(this.historyPresentIllness, "updatedAt", updatedAt);
    },
    validateForm() {
      this.errors = {};

      if (!this.historyPresentIllness.description?.trim()) {
        this.errors.description = "O H.M.A. não pode estar vazio.";
      }
    },
  },
};
</script>

<style scoped></style>
